import * as types from './types'
import { listRegions } from '@cbgms/api/modules/support/requests'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { GETRegionsResponse } from '@cbgms/api'
import {
  IAddressAutocomplete,
  IAddressSearchResolveResult,
  getAddressSearchAutoCompleteRequest,
  getAddressSearchByIdAutoCompleteRequest,
  getAddressSearchResolveRequest
} from '@cbgms/api/modules/miscellaneous/address/search'
import {
  ADDRESS_SEARCH_AUTOCOMPLETE,
  ADDRESS_SEARCH_AUTOCOMPLETE_FAILED,
  ADDRESS_SEARCH_AUTOCOMPLETE_SUCCESS,
  ADDRESS_SEARCH_ID_AUTOCOMPLETE,
  ADDRESS_SEARCH_ID_AUTOCOMPLETE_FAILED,
  ADDRESS_SEARCH_ID_AUTOCOMPLETE_SUCCESS,
  ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE,
  ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_FAILED,
  ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_SUCCESS
} from './types'
import { GETArrayResponse, GETResponse } from '@cbgms/api/helpers'

export const getAWSRegions = () =>
  AsyncAction<GETRegionsResponse>({
    type: [types.GET_REGIONS, types.GET_REGIONS_SUCCESS, types.GET_REGIONS_FAILED],
    payload: {
      api: 'support',
      request: listRegions()
    }
  })

export const setRegion = (region: string) => ({
  type: types.SET_REGION,
  payload: {
    region
  }
})

export const AddressSearchAutocomplete = (country: string, searchString: string) =>
  AsyncAction<GETArrayResponse<IAddressAutocomplete>>({
    type: [ADDRESS_SEARCH_AUTOCOMPLETE, ADDRESS_SEARCH_AUTOCOMPLETE_SUCCESS, ADDRESS_SEARCH_AUTOCOMPLETE_FAILED],
    payload: { ...getAddressSearchAutoCompleteRequest(country, searchString), api: 'support' }
  })

export const AddressSearchByIdAutocomplete = (country: string, id: string) =>
  AsyncAction<GETArrayResponse<IAddressAutocomplete>>({
    type: [ADDRESS_SEARCH_ID_AUTOCOMPLETE, ADDRESS_SEARCH_ID_AUTOCOMPLETE_SUCCESS, ADDRESS_SEARCH_ID_AUTOCOMPLETE_FAILED],
    payload: { ...getAddressSearchByIdAutoCompleteRequest(country, id), api: 'support' }
  })

export const AddressSearchResolve = (country: string, searchString: string) =>
  AsyncAction<GETResponse<IAddressSearchResolveResult>>({
    type: [ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE, ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_SUCCESS, ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_FAILED],
    payload: { ...getAddressSearchResolveRequest(country, searchString), api: 'support' }
  })
